export enum LicenseStatus {
    CHECKING = 'CHECKING',
    VALID = 'VALID',
    INVALID = 'INVALID',
    ERROR = 'ERROR',
}

export interface LicenseConfigurationData {
    productConfigurationType: string;
    ocr: boolean;
    translation: boolean;
    documentAnalysis: boolean;
    digitalisation: boolean;
    sharepoint: boolean;
    activeDirectory: boolean;
}

export interface LicenseInformationResponse {
    key: string;
    assignedTo: string;
    productType: string;
    validUntil: string; // iso date
    onlineAvailable: boolean;
    organisation: string;
    maxUsers: number;
    subscriptionType: string; // specify type
    activationDate: string; // iso date
    workMode: string; // specify type
    dayTimeRemaining: number;
    timeRemainingPercent: number; // returns null for now
    expirationDate: string; // iso date
    configurationInformation: {
        name: string;
        licenseConfigurationData: LicenseConfigurationData,
    }
}